import { ISelectableItem } from '../../components/selectableItem/selectableItemConverters';
import { TabType } from '../../components/wizard/wizardTabs/WizardTabPane';

export enum WizardPageActionTypes {
    FETCH_REQUEST_Models = '@@wizardPage/FETCH_REQUEST_MODELS',
    FETCH_SUCCESS_Models = '@@wizarPage/FETCH_SUCCESS_MODELS',

    FETCH_REQUEST_Infotaiments = '@@wizardPage/FETCH_REQUEST_INFOTAIMENTS',
    FETCH_SUCCESS_Infotaiments = '@@wizarPage/FETCH_SUCCESS_INFOTAIMENTS',

    FETCH_REQUEST_ProductionPeriods = '@@wizardPage/FETCH_REQUEST_PRODUCTION_PERIOD',
    FETCH_SUCCESS_ProductionPeriods = '@@wizarPage/FETCH_SUCCESS_PRODUCTION_PERIOD',

    FETCH_REQUEST_VinCheckResult = '@@wizardPage/FETCH_REQUEST_VIN_RESULT',
    FETCH_SUCCESS_VinCheckResult = '@@wizardPage/FETCH_SUCCESS_VIN_RESULT',
    FETCH_FAILURE_VinCheckResult = '@@wizardPage/FETCH_FAILURE_VIN_RESULT',

    SHOW_WizardPage = '@@wizardPage/SHOW',
    HIDE_WizardPage = '@@wizardPage/HIDE'
}

// Declare state types with `readonly` modifier to get compile time immutability.
export interface WizardState {
    readonly isVisible: boolean
    readonly loading: boolean
    readonly externalWizardPageActivation: boolean
    readonly changedProductionPeriods: boolean
    readonly activateFilterOnClose: boolean
    readonly wizardTab: TabType
    readonly models: ISelectableItem[]
    readonly infotaiments: ISelectableItem[]
    readonly productionPeriods: ISelectableItem[]
    readonly errors?: string
    readonly vinCheckResult: any
    readonly changedVinCheckResult: boolean
    readonly vinCheck: boolean
}
